import { ref as i, onBeforeMount as s, onBeforeUnmount as r } from "vue";
import { isBrowser as m } from "./ghl-ui.es1167.js";
const e = i(!1), n = () => {
  e.value = !0;
}, t = () => {
  e.value = !1;
};
let o = 0;
const f = () => (m && (s(() => {
  o || (window.addEventListener("compositionstart", n), window.addEventListener("compositionend", t)), o++;
}), r(() => {
  o <= 1 ? (window.removeEventListener("compositionstart", n), window.removeEventListener("compositionend", t), o = 0) : o--;
})), e);
export {
  f as useIsComposing
};
